export const FRONTOFFICE_CONDIVISO = 
{
	STATO_PAGABILE: "frontoffice/condiviso/stato/pagabile",
	STATO_PAGATO: "frontoffice/condiviso/stato/pagato",
	STATO_NON_PAGABILE: "frontoffice/condiviso/stato/non_pagabile",
	BREADCRUMBS: "frontoffice/condiviso/breadcrumbs",
	SOLOPAGABILI: "frontoffice/condiviso/soloPagabili",
	PREAVVISO: "frontoffice/condiviso/preavviso",
};

export const FRONTOFFICE_HOME = 
{
	SPID_ATTIVO: "frontoffice/home/spid/attivo",
	CIE_ATTIVO: "frontoffice/home/cie/attivo",
	CHIAVE_WEB_ATTIVO: "frontoffice/home/chiave_web/attivo",
};

export const FRONTOFFICE_ELENCO_VERBALI = 
{
	TITOLO: "frontoffice/elenco_verbali/titolo",
	SOTTOTITOLO: "frontoffice/elenco_verbali/sottotitolo",
	PLACEHOLDER_RICERCA: "frontoffice/elenco_verbali/placeholder_ricerca",
	DATA_INFRAZIONE: "frontoffice/elenco_verbali/data_infrazione",
	DATA_CONTESTAZIONE: "frontoffice/elenco_verbali/data_contestazione",
	NESSUN_VERBALE_TROVATO: "frontoffice/elenco_verbali/nessun_verbale_trovato",
};

export const FRONTOFFICE_VERBALE = 
{
	BREADCRUMBS: "frontoffice/verbale/breadcrumbs",
	TITOLO: "frontoffice/verbale/titolo",
	SOTTOTITOLO: "frontoffice/verbale/sottotitolo",
	SOTTOTITOLO_PAGATO: "frontoffice/verbale/sottotitolo_pagato",
	TABS_INFORMATIVA: "frontoffice/verbale/tabs/informativa",
	TABS_DATI_PERSONALI: "frontoffice/verbale/tabs/dati_personali",
	TABS_LISTA_VERBALI: "frontoffice/verbale/tabs/lista_verbali",
	TABS_DATI_VERBALE: "frontoffice/verbale/tabs/dati_verbale",
	TABS_DATI_PAGAMENTO: "frontoffice/verbale/tabs/dati_pagamento",
	TABS_RIEPILOGO: "frontoffice/verbale/tabs/riepilogo",
	BOTTONI_CONFERMA_E_PAGA: "frontoffice/verbale/bottoni/conferma_e_paga",
	BOTTONI_ESCI_DAL_VERBALE: "frontoffice/verbale/bottoni/esci_dal_verbale",
	BOTTONI_AVANTI: "frontoffice/verbale/bottoni/avanti",
	BOTTONI_PAGA: "frontoffice/verbale/bottoni/paga",
	BOTTONI_INDIETRO: "frontoffice/verbale/bottoni/indietro",
	ERRORI_CHIAVE_NON_IN_SESSIONE: "frontoffice/verbale/errori/chiave_non_in_sessione",
};

export const FRONTOFFICE_VERBALE_INFORMATIVA = 
{
	TITOLO: "frontoffice/verbale_informativa/titolo",
	INFORMATIVA: "frontoffice/verbale_informativa/informativa",
	CONFERMA: "frontoffice/verbale_informativa/conferma",
};

export const FRONTOFFICE_VERBALE_DATI_PERSONALI = 
{
	TITOLO: "frontoffice/verbale_dati_personali/titolo",
	SOTTOTITOLO: "frontoffice/verbale_dati_personali/sottotitolo",
	CODICE_FISCALE: "frontoffice/verbale_dati_personali/codice_fiscale",
	DATA_NASCITA: "frontoffice/verbale_dati_personali/data_nascita",
};

export const FRONTOFFICE_VERBALE_PAGAMENTO = 
{
	TITOLO: "frontoffice/verbale_pagamento/titolo",
	DESCRIZIONE: "frontoffice/verbale_pagamento/descrizione",
	OPZIONE_TITOLO: "frontoffice/verbale_pagamento/opzione/titolo",
	OPZIONE_IMPORTO_RIDOTTO: "frontoffice/verbale_pagamento/opzione/importo_ridotto",
	OPZIONE_IMPORTO_ORDINARIO: "frontoffice/verbale_pagamento/opzione/importo_ordinario",
	OPZIONE_IMPORTO: "frontoffice/verbale_pagamento/opzione/importo",
	OPZIONE_IMPORTO_PAGATO: "frontoffice/verbale_pagamento/opzione/importo_pagato",
	OPZIONE_CODICE_AVVISO: "frontoffice/verbale_pagamento/opzione/codice_avviso",
};

export const FRONTOFFICE_PREAVVISO = 
{
	DESCRIZIONE: "frontoffice/preavviso/descrizione",
	CODICE_AVVISO: "frontoffice/preavviso/codice_avviso",
	ENTE_CREDITORE: "frontoffice/preavviso/ente_creditore",
	CODICE_FISCALE_ENTE: "frontoffice/preavviso/codice_fiscale_ente",
	TARGA_VEICOLO: "frontoffice/preavviso/targa_veicolo",
	DATA_RILEVAZIONE: "frontoffice/preavviso/data_rilevazione",
	IMPORTO: "frontoffice/preavviso/importo",
	MESSAGGIO_ERRORE_FORMATO: "frontoffice/preavviso/messaggio_errore_formato",
	MESSAGGIO_ERRORE_CHIAMATA: "frontoffice/preavviso/messaggio_errore_chiamata",
	BOTTONE_PAGAMENTO: "frontoffice/preavviso/bottone_pagamento",
};

export const FRONTOFFICE_VERBALE_RITORNO_PAGAMENTO = 
{
	BREADCRUMBS: "frontoffice/verbale_ritorno_pagamento/breadcrumbs",
	EFFETTUATO: "frontoffice/verbale_ritorno_pagamento/effettuato",
	EFFETTUATO_FRASE: "frontoffice/verbale_ritorno_pagamento/effettuato_frase",
	FALLITO: "frontoffice/verbale_ritorno_pagamento/fallito",
	FALLITO_FRASE: "frontoffice/verbale_ritorno_pagamento/fallito_frase",
	IMPORTO: "frontoffice/verbale_ritorno_pagamento/importo",
	INVIATO: "frontoffice/verbale_ritorno_pagamento/inviato",
	TORNA_VERBALE: "frontoffice/verbale_ritorno_pagamento/torna_verbale",
	RICEVUTA: "frontoffice/verbale_ritorno_pagamento/ricevuta",
};

export const FRONTOFFICE_VERBALE_RIEPILOGO = 
{
	TITOLO: "frontoffice/verbale_riepilogo/titolo",
	SOTTOTITOLO: "frontoffice/verbale_riepilogo/sottotitolo",
	TITOLO_CON_PAGAMENTO: "frontoffice/verbale_riepilogo/titolo_con_pagamento",
	SOTTOTITOLO_CON_PAGAMENTO: "frontoffice/verbale_riepilogo/sottotitolo_con_pagamento",
	SEZIONI_DATI_VERBALE: "frontoffice/verbale_riepilogo/sezioni/dati_verbale",
	SEZIONI_NUMERO_VERBALE: "frontoffice/verbale_riepilogo/sezioni/numero_verbale",
	SEZIONI_DATA_INFRAZIONE: "frontoffice/verbale_riepilogo/sezioni/data_infrazione",
	SEZIONI_DATA_CONTESTAZIONE: "frontoffice/verbale_riepilogo/sezioni/data_contestazione",
	SEZIONI_NORMATIVA: "frontoffice/verbale_riepilogo/sezioni/normativa",
	SEZIONI_NORMATIVA_VIOLAZIONE: "frontoffice/verbale_riepilogo/sezioni/normativa/violazione",
	SEZIONI_NORMATIVA_PUNTI: "frontoffice/verbale_riepilogo/sezioni/normativa/punti",
	SEZIONI_INTESTATARIO: "frontoffice/verbale_riepilogo/sezioni/intestatario",
	SEZIONI_VEICOLO: "frontoffice/verbale_riepilogo/sezioni/veicolo",
	SEZIONI_MODALITA_PAGAMENTO: "frontoffice/verbale_riepilogo/sezioni/modalita_pagamento",
	SEZIONI_PAGAMENTO: "frontoffice/verbale_riepilogo/sezioni/pagamento",
	SEZIONI_DOCUMENTI_SCARICABILI: "frontoffice/verbale_riepilogo/sezioni/documenti_scaricabili",
	SEZIONI_DOCUMENTI_SCARICABILI_SOTTOTITOLO: "frontoffice/verbale_riepilogo/sezioni/documenti_scaricabili/sottotitolo",
	ULTERIORI_INFO: "frontoffice/verbale_riepilogo/ulteriori_info",
};

export const FRONTOFFICE_URI = 
{
	HOME: "frontoffice/uri/home",
};

export const FRONTOFFICE_TITLE = 
"frontoffice/title";
export const FRONTOFFICE_PORTALE = 
{
	URI_PAGAMENTO: "frontoffice/portale/uri/pagamento",
	URI_PUNTI: "frontoffice/portale/uri/punti",
};

